/**
 * Client-side personnummer hints (server validates authoritatively).
 */

export function normalizePersonnummerInput(raw) {
  return String(raw || '').trim().replace(/\s/g, '');
}

export function isPersonnummerPlausible(raw) {
  const compact = normalizePersonnummerInput(raw);
  return /^(\d{6}|\d{8})[-+]?(\d{4})$/.test(compact);
}
